import { useState, useEffect } from 'react';
import { Grid, Button, Typography, Select, MenuItem, Box, Alert } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { getListAPI as getWorkerListAPI } from 'components/product2skill2exp2rate/Product2skill2exp2rateAPI';
import { setProduct2skill2exp2rateList, setProduct2skill2exp2rateDashboardProduct2skill2exp2rateList } from 'store/slice/ManufSlice';
import { convertToRS } from 'core/js/FormUtils';

import StitchingtaskInfo from './StitchingtaskInfo';
import FieldView2 from 'core/components/layout/FieldView2';
import { updateStitchingtaskInfo } from 'components/stitchingtask/StitchingtaskAPI';
import { updateStitchingtaskObj } from 'store/slice/ManufSlice';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function UpdateWorkerActionImpl() {
    const dispatch = useDispatch();
    const { product2skill2exp2rateList } = useSelector((state) => state.manufslice);
    const [selectedWorker, setSelectedWorker] = useState('');
    const { stitchingtaskObj} = useSelector((state)=>state.manufslice.stitchingtaskDashboard);
    const [workerList, setWorkerList] = useState([]);
    const [selectedWorkerObj, setSelectedWorkerObj] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
       if (product2skill2exp2rateList.length===0) {
           getWorkerListAPI(()=>{},
           (response)=>{
                dispatch(setProduct2skill2exp2rateList(response));
           });
       }
    }, []);
    useEffect(() => {
       if (product2skill2exp2rateList.length>0 && stitchingtaskObj) {
        setWorkerList(
            product2skill2exp2rateList.filter(item => item.productid===stitchingtaskObj.productid)
           )
       }
    }, [product2skill2exp2rateList,stitchingtaskObj]);
    useEffect(() => {
       if (selectedWorkerObj) {
           console.log('Selected Worker Object:', JSON.stringify(selectedWorkerObj));
       }
    }, [selectedWorkerObj]);

    const handleWorkerChange = (workerId) =>{
        setSelectedWorker(workerId);
        setSelectedWorkerObj(product2skill2exp2rateList.find(item => item.id === workerId));
    }

    const handleUpdateWorker = () => {
      if (selectedWorkerObj && stitchingtaskObj) {
        updateStitchingtaskInfo(
          stitchingtaskObj.id,
          {
            workerid: selectedWorkerObj.workerid,
            workername: selectedWorkerObj.workername,
            earning: selectedWorkerObj?.rate * stitchingtaskObj.assignedqty
          },
          (response) => {
            dispatch(updateStitchingtaskObj(response));
            setSuccess(true);
            setTimeout(() => setSuccess(false), 2000); // Hide after 2 seconds
          }
        );
      }
    };

    return (
        <Grid container>
            <Grid item xs={12} lg={8}>
                <StitchingtaskInfo />
            </Grid>
            <Grid item lg={1}>&nbsp;</Grid>
            <Grid item xs={12} lg={3}>
                <Grid container sx={{ backgroundColor: 'white', p: 1, borderRadius: 2 }}>
                    <Grid item xs={12} lg={12}><Typography variant="h6">Update Worker</Typography></Grid>
                    <Grid item xs={12} lg={12}>
                        <Select
                            fullWidth
                            value={selectedWorker}
                            onChange={e => handleWorkerChange(e.target.value)}
                            displayEmpty
                            sx={{ mt: 1 }}
                        >
                            <MenuItem value="" disabled>Select Worker</MenuItem>
                            {workerList.length > 0 && workerList.map((item, idx) => (
                                <MenuItem key={item.id || idx} value={item.id || idx}>
                                    {item.workername}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item xs={12} lg={12} sx={{}}>
                        <Box sx={{backgroundColor:'white', display:'flex', justifyContent:'flex-end', p:1}}>
                            <FieldView2 label="Stitching Rate" value={selectedWorkerObj?.rate} />
                            <FieldView2 label="Earning" value={convertToRS(selectedWorkerObj?.rate * stitchingtaskObj.assignedqty)} />
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={12} sx={{ mb: 1 }}>
                        {success && (
                          <Alert
                            icon={<CheckCircleIcon fontSize="inherit" sx={{ color: 'green' }} />}
                            severity="success"
                            sx={{ alignItems: 'center', mb: 1, p: 1, bgcolor: 'success.100', color: 'success.main' }}
                          >
                            Worker updated successfully!
                          </Alert>
                        )}
                    </Grid>
                    <Grid container justifyContent="flex-end">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleUpdateWorker}
                          disabled={!selectedWorkerObj}
                        >
                          Update Worker
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}